import { useDispatch } from 'react-redux'
import { setSkipped, setCompleted } from 'redux/slices/activeWorkout'
import { PencilSquareIcon, ArrowPathIcon, ArrowUturnLeftIcon, ForwardIcon, CheckCircleIcon } from '@heroicons/react/24/outline'

import LabelledIconButton from 'components/Buttons/LabelledIconButton'

export default function ActionButtons({
    version = '4.0',
    profileType,
    groupId,
    athleteId,
    // taperData,
    // workoutType,
    phaseIndex,
    exerciseIndex,
    exercise,
    setIndex,
    set,
    isCompleted,
    isSkipped,
    isRecommendation,
    showLabel = true,
    OnSwapButton = () => {},
    OnUndoSwapButton = () => {},
    // ApplyMDSRepsAdjustment = () => {},
    // ApplyLDSLoadAdjustment = () => {}
    MutateRemainingSets = () => {},
}) {

    const dispatch = useDispatch()

    const OnEditButton = () => {

        const payload = {
            profileType: profileType,
            groupId: groupId,
            athleteId: athleteId,
            phaseIndex: phaseIndex,
            exerciseIndex: exerciseIndex,
            setIndex: setIndex,
            value: false
        }

        dispatch(setCompleted(payload))
        dispatch(setSkipped(payload))

        // For group recalculate all weight recommendations

        if (
            profileType === 'group'
            && exercise.exerciseType === 'recommendation'
        ) {

            const mutatePayload = {
                phaseIndex: phaseIndex,
                exerciseIndex: exerciseIndex,
                mutationKey: 'recalculate-weight-recommendation'
            }

            MutateRemainingSets(mutatePayload)

        }

    }

    const OnSkipButton = () => {

        const payload = {
            profileType: profileType,
            groupId: groupId,
            athleteId: athleteId,
            phaseIndex: phaseIndex,
            exerciseIndex: exerciseIndex,
            setIndex: setIndex,
            value: true
        }


        dispatch(setSkipped(payload))
        
    }

    const OnSaveButton = () => {

        // Do not allow a set to be saved if the weight recommendation is still loading in

        if (
            exercise.exerciseType === 'recommendation' &&
            set.recommendationData.weightRecommendationLoaded === false
        ) {
            return
        }

        // Update redux store

        const setCompletionPayload = {
            profileType: profileType,
            groupId: groupId,
            athleteId: athleteId,
            phaseIndex: phaseIndex,
            exerciseIndex: exerciseIndex,
            setIndex: setIndex,
            value: true
        }

        dispatch(setCompleted(setCompletionPayload))

        // Recalculate weight recommendations

        if (exercise.exerciseType === 'recommendation') {

            const mutatePayload = {
                phaseIndex: phaseIndex,
                exerciseIndex: exerciseIndex,
                mutationKey: 'recalculate-weight-recommendation'
            }

            MutateRemainingSets(mutatePayload)

        }

        // Apply adjustments

        /*
        if (
            profileType === 'group'
            || profileType === 'individual'
        ) {
            if (workoutType === 'program') {

                // Bodyweight exercises

                if (exercise.exerciseType === 'bodyweight') {

                    // Normal weeks: Apply MDS adjustments

                    if (taperData.useTaper === false) {
                        ApplyMDSRepsAdjustment()
                    }

                    // Maintain weeks: Apply MDS adjustments (DOWN ONLY)

                    if (
                        taperData.useTaper === true &&
                        taperData.taperDampener === 1.00 &&
                        set.completedSetData.movementDifficulty > 0
                    ) {
                        // console.log('MAINTAIN WEEK EDGE CASE. DOWN ONLY.')
                        ApplyMDSRepsAdjustment()
                    }

                    // Deload weeks: Apply MDS adjustments (DOWN ONLY)

                    if (
                        taperData.useTaper === true &&
                        taperData.taperDampener < 1.00 &&
                        set.completedSetData.movementDifficulty > 0
                    ) {
                        // console.log('DELOAD WEEK EDGE CASE. DOWN ONLY.')
                        ApplyMDSRepsAdjustment()
                    }

                }

                // Recommendation exercises

                if (exercise.exerciseType === 'recommendation') {
                    ApplyLDSLoadAdjustment()
                }
                
            }
        }
        */

    }

    // Edit Button

    if (isSkipped || isCompleted) {
        return (
            <div className='space-y-2'>
                {showLabel && (
                    <div className='text-xs text-center text-gray-600'>Edit</div>
                )}

                <div className='w-20 h-20'>
                    <LabelledIconButton
                        icon={<PencilSquareIcon className='w-10 h-10 text-gray-500' />}
                        action={OnEditButton}
                    />
                </div>
            </div>
        )
    }

    // Skip, Swap, and Save Buttons

    return (
        <>
            {version === '4.0' && 
                <>
                    {exercise.originalExerciseStorage === null && (
                        <div className='space-y-2'>
                            {showLabel && (
                                <div className='text-xs text-center text-gray-600'>Swap</div>
                            )}

                            <div className='w-20 h-20'>
                                <LabelledIconButton
                                    icon={<ArrowPathIcon className='w-10 h-10 text-gray-500' />}
                                    action={OnSwapButton}
                                />
                            </div>
                        </div>
                    )}
                    
                    {exercise.originalExerciseStorage !== null && (
                        <div className='space-y-2'>
                            {showLabel && (
                                <div className='text-xs text-center text-gray-600'>Undo</div>
                            )}

                            <div className='w-20 h-20'>
                                <LabelledIconButton
                                    icon={<ArrowUturnLeftIcon className='w-10 h-10 text-gray-500' />}
                                    action={OnUndoSwapButton}
                                />
                            </div>
                        </div>
                    )}
                </>
            }
            
            <div className='space-y-2'>
                {showLabel && (
                    <div className='text-xs text-center text-gray-600'>Skip</div>
                )}

                <div className='w-20 h-20'>
                    <LabelledIconButton
                        icon={<ForwardIcon className='w-10 h-10 text-gray-500' />}
                        action={OnSkipButton}
                    />
                </div>
            </div>

            <div className='space-y-2'>
                {showLabel && (
                    <div className='text-xs text-center text-gray-600'>Save</div>
                )}

                <div className='w-20 h-20'>
                    <LabelledIconButton
                        icon={<CheckCircleIcon className='w-10 h-10 text-white' />}
                        style="brand-color"
                        disabled={isRecommendation && !set.recommendationData.weightRecommendationLoaded}
                        action={OnSaveButton}
                    />
                </div>
            </div>
        </>
    )
}
